module.exports = __webpack_public_path__ + "static/media/adaptive-led-headlamp.f1b83b89.jpg";